<template>
  <!--begin::Content wrapper-->
  <input type="hidden" id="ClassId" name="" value="" />

  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="video-modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered" style="max-width: 1000px">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title class-title">Academia</h5>
          <div>
            <button 
              type="button" 
              class="btn btn-primary me-2" 
              @click="shareVideo"
              title="مشاركة الرابط"
            >
              <i class="fa fa-share"></i> مشاركة
            </button>
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">
              <i class="fa fa-close"></i> إغلاق
            </button>
          </div>
        </div>

        <div class="modal-body">
          <!-- ✅ الفيديو -->
          <div class="video-box text-center" id="video-loader"></div>
          <div
            class="video-box text-center mb-4"
            id="video-section"
            style="height: 500px; width: 100%"
          ></div>

          <!-- ✅ قسم الملاحظات -->
          <div class="notes-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h5 class="mb-0">الملاحظات</h5>
              <button class="btn btn-green btn-sm" @click="openNoteModal()">
                <i class="fa fa-plus text-white"></i> إضافة ملاحظة
              </button>
            </div>

            <div
              v-if="qbankNotes && qbankNotes.length"
              class="notes-list"
              style="max-height: 300px; overflow-y: auto"
            >
              <div
                v-for="note in qbankNotes"
                :key="note.id"
                class="card note-card mb-3 shadow-sm"
              >
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="card-title mb-1">
                      {{ note.user?.name || "مستخدم غير معروف" }}
                    </h6>
                    <small class="text-muted">{{ formatTime(note.timestamp) }}</small>
                  </div>
                  <p class="card-text my-2">{{ note.note }}</p>
                  <div class="d-flex justify-content-end">
                    <button
                      class="btn btn-sm btn-green-outline me-2 text-white"
                      style="background-color: #00c744 !important"
                      @click="openNoteModal(note)"
                    >
                      <i class="fa fa-edit text-white"></i> تعديل
                    </button>
                    <button class="btn btn-sm btn-danger" @click="deleteNote(note.id)">
                      <i class="fa fa-trash text-white"></i> حذف
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="alert alert-info text-center">لا توجد ملاحظات بعد</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ✅ مودال إضافة/تعديل ملاحظة -->
  <div class="modal fade" id="noteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-green text-white">
          <h5 class="modal-title">
            {{ editingNote ? "تعديل ملاحظة" : "إضافة ملاحظة" }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveNote">
            <div class="mb-3">
              <label class="form-label">النص</label>
              <textarea
                v-model="noteForm.note"
                class="form-control"
                rows="8"
                style="height: 120px"
                required
              ></textarea>
            </div>

            <button type="submit" class="btn btn-green w-100">
              {{ editingNote ? "تحديث" : "حفظ" }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";

export default {
  name: "VideoClass",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      qbankNotes: [],
      isLoading: false,
      editingNote: null,
      noteForm: {
        note: "",
        timestamp: "",
      },
    };
  },
  methods: {
    async shareVideo() {
      try {
        // Get the current video ID from the hidden input
        const videoId = document.getElementById('ClassId').value;
        if (!videoId) {
          throw new Error('لم يتم العثور على معرّف الفيديو');
        }
        
        // Get current URL and its parameters
        const currentUrl = new URL(window.location.href);
        
        // Update or add the vc parameter
        currentUrl.searchParams.set('vc', videoId);
        
        // Get the full URL with all parameters
        const shareUrl = currentUrl.toString();
        
        try {
          // Try modern clipboard API first
          await navigator.clipboard.writeText(shareUrl);
          this.showSuccessMessage(shareUrl);
        } catch (err) {
          console.error('Failed to copy URL with modern API: ', err);
          // Fallback for browsers that don't support clipboard API
          await this.fallbackCopyToClipboard(shareUrl);
        }
      } catch (error) {
        console.error('Error in shareVideo:', error);
        Swal.fire({
          title: 'خطأ',
          text: 'حدث خطأ أثناء محاولة نسخ الرابط',
          icon: 'error',
          confirmButtonText: 'حسناً',
          confirmButtonColor: '#f64e60',
        });
      }
    },
    
    showSuccessMessage(shareUrl) {
      return Swal.fire({
        title: 'تم النسخ بنجاح',
        html: `
          <div dir="rtl">
            <p>تم نسخ رابط الفيديو بنجاح</p>
            <p> يمكنك الان مشاركته</p>
          </div>
        `,
        icon: 'success',
        confirmButtonText: 'حسناً',
        confirmButtonColor: '#00c744',
      });
    },
    
    fallbackCopyToClipboard(shareUrl) {
      return new Promise((resolve, reject) => {
        const textArea = document.createElement('textarea');
        textArea.value = shareUrl;
        textArea.style.position = 'fixed';
        textArea.style.opacity = 0;
        document.body.appendChild(textArea);
        textArea.select();
        
        try {
          const successful = document.execCommand('copy');
          document.body.removeChild(textArea);
          
          if (successful) {
            this.showSuccessMessage(shareUrl);
            resolve();
          } else {
            throw new Error('فشل نسخ الرابط');
          }
        } catch (err) {
          document.body.removeChild(textArea);
          reject(err);
        }
      });
    },
    async showClassNotes() {
      let ClassId = document.getElementById("ClassId").value;
      this.isLoading = true;
      try {
        const response = await fetch(`${apiUrl}/course-classes/${ClassId}/notes`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
            "x-country-code": "+218",
          },
        });

        if (response.ok) {
          const data = await response.json();
          this.qbankNotes = data.data;
        } else {
          console.error("Failed to fetch notes");
        }
      } catch (error) {
        console.error("Error fetching notes:", error);
      } finally {
        this.isLoading = false;
      }
    },

    formatTime(time) {
      return time ? time.split(".")[0] : "";
    },

    openNoteModal(note = null) {
      this.editingNote = note;
      if (note) {
        this.noteForm = { note: note.note, timestamp: note.timestamp };
      } else {
        this.noteForm = { note: "", timestamp: "" };
      }
      new bootstrap.Modal(document.getElementById("noteModal")).show();
    },

    async saveNote() {
      try {
        if (this.editingNote) {
          // ✅ تعديل مع تأكيد
          Swal.fire({
            title: "هل تريد حفظ التعديلات؟",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#00c744",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "نعم، حفظ",
            cancelButtonText: "إلغاء",
          }).then(async (result) => {
            if (result.isConfirmed) {
              const response = await fetch(`${apiUrl}/course-classes/note/update`, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${this.token}`,
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  note_id: this.editingNote.id,
                  note: this.noteForm.note,
                }),
              });
              if (response.ok) {
                Swal.fire("تم", "تم تحديث الملاحظة بنجاح", "success");
                this.showClassNotes();
                bootstrap.Modal.getInstance(document.getElementById("noteModal")).hide();
              }
            }
          });
        } else {
          // ✅ إضافة
          let ClassId = document.getElementById("ClassId").value;
          let videoCurrentTime = document.getElementById("videoCurrentTime").value;

          function formatTime(seconds) {
            const sec = Math.floor(seconds % 60);
            const min = Math.floor((seconds % 3600) / 60);
            const hrs = Math.floor(seconds / 3600);
            return [hrs, min, sec].map((v) => (v < 10 ? "0" + v : v)).join(":");
          }
          let formattedTime = formatTime(videoCurrentTime);

          const response = await fetch(`${apiUrl}/course-classes/note`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
              "x-country-code": "+218",
            },
            body: JSON.stringify({
              note: this.noteForm.note,
              timestamp: formattedTime,
              course_class_id: ClassId,
            }),
          });
          if (response.ok) {
            Swal.fire("تم", "تمت إضافة الملاحظة بنجاح", "success");
            this.showClassNotes();
            bootstrap.Modal.getInstance(document.getElementById("noteModal")).hide();
          }
        }
      } catch (error) {
        Swal.fire("خطأ", "حدثت مشكلة في العملية", "error");
      }
    },

    async deleteNote(id) {
      Swal.fire({
        title: "هل أنت متأكد؟",
        text: "لا يمكنك التراجع بعد الحذف",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "نعم، احذف",
        cancelButtonText: "إلغاء",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await fetch(`${apiUrl}/course-classes/note`, {
              method: "DELETE",
              headers: {
                Authorization: `Bearer ${this.token}`,
                "Content-Type": "application/json",
                "x-country-code": "+218",
              },
              body: JSON.stringify({ note_id: id }),
            });
            if (response.ok) {
              Swal.fire("تم", "تم حذف الملاحظة", "success");
              this.showClassNotes();
            }
          } catch (error) {
            Swal.fire("خطأ", "تعذر حذف الملاحظة", "error");
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.notes-section {
  border-top: 1px solid #ddd;
  padding-top: 15px;
}

.note-card {
  border: 1px solid #00c744;
  border-left: 4px solid #00c744;
  border-radius: 12px;
  transition: 0.2s ease-in-out;
}
.note-card:hover {
  transform: scale(1.01);
  box-shadow: 0 6px 15px rgba(0, 199, 68, 0.2);
}

.bg-green {
  background-color: #00c744 !important;
}

.btn-green {
  background-color: #00c744;
  border-color: #00c744;
  color: #fff;
}
.btn-green:hover {
  background-color: #00a83b;
  border-color: #009934;
  color: #fff;
}

.btn-green-outline {
  border: 1px solid #00c744;
  color: #00c744;
  background-color: transparent;
}
.btn-green-outline:hover {
  background-color: #00c744;
  color: #fff;
}
</style>
